import { useEffect, useRef, useState } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import "./LiveTextControls.scss";

const LiveTextMessageStatus = (props) => {
    const [tick, setTick] = useState(0);
    const [allowCommandButtons, setAllowCommandButtons] = useState(false);

    const getStateData = () => {
        let stateData = null;
        if (props.previewControls && props?.passedInPreviewData?.liveTextStatus) {
            stateData = props.passedInPreviewData.liveTextStatus;
        }
        if (stateData === null) {
            stateData = props?.featureVars?.liveTextStatus;
        }
        if (stateData) {
            return stateData;
        }
        // Default state data
        return {
            activeMessages: [],
            queuedMessages: [],
        };
    }

    const stateData = getStateData();
    console.log('LiveTextMessageStatus stateData', stateData);
    const templatesData = props.customisationData?.setup?.templates?.settings;

    useEffect(() => {
        console.log('LiveTextMessageStatus props', props);
        setTick((t) => t + 1);
        setAllowCommandButtons(true);
    }, [props]);

    return (
        <div className="fl-column">
            <div className="fl-row compact">
                <div className="label shrink">Active Messages:</div>
                <div className="label grow">{stateData.activeMessages.length}</div>
            </div>
            <div className="fl-column lt-mess-list-box">
                {stateData.activeMessages.map((message, index) => {
                    return (
                        <div key={index} className={`one-live-message-status${message.isResponse ? ' response' : ''} fl-column compact`}>
                            <div className="fl-row compact">
                                <div className="shrink">Template:</div>
                                <div className="shrink dark-text">
                                    {templatesData && templatesData.length &&
                                        <>{templatesData[message.templateIndex].templateName}</>
                                    }
                                    {(!templatesData || templatesData.length === 0) &&
                                        <>Unknown</>
                                    }
                                    {message.isResponse &&
                                        <span className="light-text"> (Response)</span>
                                    }
                                </div>
                                <div className="grow"></div>
                                <div className={`small-lt-control-btn ${allowCommandButtons ? 'red' : 'grey'} shrink`} onClick={allowCommandButtons ? (e) => {props.sendFeatureCommandFunc(e, 'HIDE_LIVE_TEXT_MESSAGE', props.featureId, index); setAllowCommandButtons(false)} : null}>Hide Now</div>
                            </div>
                            <div className="fl-column no-gap">
                                <div className="grow bold-text dark-text">{message.headerText}</div>
                                <div className="grow dark-text">{message.mainContent}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default LiveTextMessageStatus;
